import { ROUTES } from './routes';
import { webConfig } from './webConfig';

export const navigateToHomepage = (isLoggedIn: boolean) => {
    if (isLoggedIn) {
        window.location.href = ROUTES.donate;
    } else {
        window.location.href = webConfig.mainSearchSite;
    }
};
